export const listRegulationsCampaign = (campaignId, catalogId) => {
  return {
    type: 'LIST_REGULATION',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v2/campaigns/regulations?campaignId=${campaignId}&catalogId=${catalogId}`
      }
    },
    campaignId,
    catalogId
  }
}

export const listRegulationsVendor = (campaignId, catalogId, vendorId) => {
  return {
    type: 'LIST_REGULATION',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v2/campaigns/regulations/store?catalogId=${catalogId}&vendorId=${vendorId}`
      }
    },
    catalogId,
    vendorId,
    campaignId
  }
}

export const listRegulationsVendorAndRegulationType = (
  campaignId,
  catalogId,
  vendorId,
  regulationType
) => {
  return {
    type: 'LIST_REGULATION',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/configurations/regulations/vendor/${vendorId}/${regulationType}`
      }
    },
    campaignId,
    catalogId,
    vendorId,
    regulationType
  }
}

export default {
  listRegulationsCampaign,
  listRegulationsVendor,
  listRegulationsVendorAndRegulationType
}



// WEBPACK FOOTER //
// ./src/features/Regulation/actions.js